import { fetch } from '@nackle/umbrella';
import { eventProxyUrl } from 'endpoints';
import { IS_LOCALHOST } from '../config';

class EventProxySDK {

    sendEvent = async( eventData, topicName ) => {
        if ( IS_LOCALHOST ) {
            return;
        }
        return new Promise( ( resolve, reject ) => {
            fetch( `${ eventProxyUrl }/topics`, {
                method: 'POST',
                headers: { 'content-type': 'application/json' },
                body: JSON.stringify( {
                    eventData,
                    topicName
                } )
            } ).then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( data ) => {

                        resolve( data );
                    } );
                }
            } ).catch( error => {
                console.log( 'Error when sending click event', error );
                throw new Error( error );
            } );
        } );
    };
}

export default new EventProxySDK();
